import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers';

/*
 ** Init store
 */
export const store = createStore(rootReducer, composeWithDevTools());

const StoreProvider: React.FC = ({ children }) => <Provider store={store}>{children}</Provider>;

export default StoreProvider;
